<p>
  I/We hereby agree and consent that the Bank may collect, use, disclose and process my/our personal information set out in this application
  form, account opening documents and/or otherwise provided by me/us or possessed by the Bank, for one or more of the purposes as stated in
  the Bank’s Personal Data Protection in the Terms And Conditions Governing The Corporate Deposits Accounts And Services (available at
  <a
    class="underline text-primary"
    href="https://www.cimb.com.sg"
    target="_blank"
    >www.cimb.com.sg</a
  >), which in summary includes but is not limited to the following:
</p>

<ol class="list-alpha">
  <li>
    <p>
      processing my/our application for and providing me/us with the services and products of the Bank as well as services and products by
      external providers provided through the Bank;
    </p>
  </li>

  <li>
    <p>administering and/or managing my/our relationship and/or accounts with the Bank; and</p>
  </li>

  <li>
    <p>
      sending me/us marketing, advertising and promotional information about other products/services that the Bank, its affiliates, business
      partners and related companies may be offering, and which the Bank believes may be of interest or benefit to me/us (“Marketing
      Messages”), by way of postal mail and/or electronic transmission to my/our email address(es);
    </p>
  </li>
</ol>

<p>Opt Out for sub-clause (c)</p>

<p>
  Please be informed that you have the right to opt out of receiving Marketing Messages. Kindly visit
  <a
    class="underline text-primary"
    href="https://www.cimb.com.sg/business"
    target="_blank"
    >www.cimb.com.sg/business</a
  >
  for further details on how you may exercise your right to opt out of receiving Marketing Messages. Kindly note that if you do not exercise
  your right to opt out of receiving such Marketing Messages, you will be deemed to have consented to the receiving of such Marketing
  Messages by the Bank, its affiliates, business partners and related companies, and the Bank, its affiliates, business partners and related
  companies will continue to provide such Marketing Messages to you.
</p>

<ol
  class="list-alpha"
  start="4"
>
  <li>
    <p>
      sending me/us marketing, advertising and promotional information about other products/services that the Bank, its affiliates, business
      partners and related companies may be offering, and which the Bank believes may be of interest or benefit to me/us (the “Marketing
      Purpose”), to my/our telephone number(s) (as set out in this application form, account opening documents and/or otherwise provided by
      me/us or possessed by the Bank) by way of:
    </p>

    <ul class="list-outside list-disc pl-6">
      <li><p>Voice call/phone call*</p></li>
      <li><p>SMS/MMS/WhatsApp/Other messaging platform (text message)*</p></li>
      <li><p>Fax*</p></li>
    </ul>
  </li>
</ol>

<p>Opt In for sub-clause (d)</p>

<p>
  *If you AGREE and CONSENT to the Bank, its affiliates, business partners and related companies and their third party service providers
  processing your personal data for the Marketing Purpose and contacting you as described in this subclause (d), indicate your preference
  for the mode of communication and consent by checking in the applicable boxes under PDPA Marketing Consent section.
</p>
